import jsonp from 'jsonp';

export default {
    serverName: 'https://iptv.kartina.tv/api/json/',
   
    // Megogo
    searchMegogo(type, {genre = '', query = '', category = '', page = '', numbs = ''}, callback) {
        jsonp(this.serverName + `mgg_list?type=${type}&genre=${genre}&query=${query}&category=${category}&page=${page}&numbs=${numbs}`, null, callback);
    },
    getMegogoItem(id, protectionCode = '', callback) {
        jsonp(this.serverName + `mgg_info?id=${id}&protect_code=${protectionCode}`, null, callback);
    },
    getMegogoGenres(callback) {
        jsonp(this.serverName + 'mgg_genres', null, callback);
    },
    getMegogoFavorites(callback) {
        jsonp(this.serverName + 'mgg_favlist', null, callback);
    },
    addToMegogoFavorites(id, callback) {
        jsonp(this.serverName + 'mgg_favadd?id=' + id, null, callback); 
    },
    removeFromMegogoFavorites(id, callback) {
        jsonp(this.serverName + 'mgg_favsub?id=' + id, null, callback);
    },
    getMegogoStreamUrl(fileId, protectionCode = '', callback) {
        jsonp(this.serverName + `mgg_geturl?fileid=${fileId}&protect_code=${protectionCode}`, null, callback);
    },
}


// WEBPACK FOOTER //
// ./src/libs/megogo.js